import { useContextMenu } from '@hooks'

import { useContextMenuHandlers } from './useContextMenuHandlers'

type Props = {
  handleClearSelectedCells: () => void
}

export const useTimeLineContextMenu = (props: Props) => {
  const { handleClearSelectedCells } = props

  const {
    position,
    onRefContextMenu,
    onClickLink,
    onExecuteCommand,
    onOpenContextMenu,
    onCloseContextMenu,
    onExecuteAction,
    printFormVouPayload,
    onClosePrintFormVou,
  } = useContextMenu({})

  const { handleContextMenu, contextMenuData } = useContextMenuHandlers({
    onOpenContextMenu,
    onClickLink,
    onExecuteCommand,
    onExecuteAction,
    onClearSelectedCells: handleClearSelectedCells,
  })

  return {
    handleContextMenu,
    onRefContextMenu,
    onCloseContextMenu,
    contextMenuData,
    position,
    printFormVouPayload,
    onClosePrintFormVou,
  }
}
